var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"align-center d-flex flex-column mb-7"},[_c('div',{staticClass:"font-weight-semibold"},[_vm._v("Please enter the code")]),_c('div',{staticClass:"d-flex flex-wrap justify-center"},[_c('div',[_vm._v("We sent an SMS code to this number:")]),_c('div',{staticClass:"font-weight-semibold"},[_vm._v("+1 "+_vm._s(_vm.phone))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }